import { type JSX } from "react";
import { OfferEditableWrap } from "@/components/ClientOfferView";
import styles from "@/components/ClientOfferView.module.css";
import type { OfferSectionProps } from "@/components/offer/offerDocumentTypes";

const DEFAULT_TERMS =
  "Rozliczenie etapowe po zakończeniu uzgodnionych etapów prac. Termin płatności: 7 dni od daty wystawienia faktury.";

export function PaymentTermsSection({ offerData }: OfferSectionProps): JSX.Element {
  const terms = offerData.paymentTerms?.trim() || DEFAULT_TERMS;
  const onChange = offerData.onPaymentTermsChange;

  return (
    <section className={styles.assumptions}>
      <div>
        <h2 className={styles.assumptionsHeading}>
          Warunki
          <br />
          płatności
        </h2>
      </div>
      <ul className={styles.assumptionsList}>
        <li className={styles.assumptionItem}>
          {onChange ? (
            <OfferEditableWrap enabled className={styles.assumptionEditableWrap}>
              <span
                contentEditable
                spellCheck={false}
                suppressContentEditableWarning
                onBlur={(e) => onChange(e.currentTarget.textContent?.trim() || undefined)}
              >
                {terms}
              </span>
            </OfferEditableWrap>
          ) : (
            <span>{terms}</span>
          )}
        </li>
      </ul>
    </section>
  );
}
